import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  User, 
  ChevronDown, 
  LogOut, 
  Heart, 
  ShoppingBag, 
  Package, 
  Shield, 
  BarChart3, 
  Settings, 
  Image,
  Search,
  Wallet
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface UserDropdownMenuProps {
  user: any;
  showArtistContent: boolean;
  showBuyerContent: boolean;
  isAdmin: boolean;
  handleSignOut: () => void;
}

export const UserDropdownMenu = ({
  showArtistContent,
  showBuyerContent,
  isAdmin,
  handleSignOut,
}: UserDropdownMenuProps) => {
  return (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="gap-1">
            <User className="h-5 w-5" />
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
        {showArtistContent && (
          <>
            <DropdownMenuItem asChild>
              <Link to="/upload" className="w-full cursor-pointer">
                <Button variant="default" className="w-full justify-start" size="sm">
                  <Package className="mr-2 h-4 w-4" />
                  Sälj nu
                </Button>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild>
          <Link to="/profile" className="cursor-pointer">
            <User className="mr-2 h-4 w-4" />
            Profil
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings" className="cursor-pointer">
            <Settings className="mr-2 h-4 w-4" />
            Inställningar
          </Link>
        </DropdownMenuItem>
        {showArtistContent && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/artist-dashboard" className="cursor-pointer">
                <BarChart3 className="mr-2 h-4 w-4" />
                Statistik
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/my-artworks" className="cursor-pointer">
                <Image className="mr-2 h-4 w-4" />
                Mina Verk
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/artist-orders" className="cursor-pointer">
                <Package className="mr-2 h-4 w-4" />
                Försäljningar
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/payouts" className="cursor-pointer">
                <Wallet className="mr-2 h-4 w-4" />
                Utbetalningar
              </Link>
            </DropdownMenuItem>
          </>
        )}
        
        {showBuyerContent && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/explore" className="cursor-pointer">
                <Search className="mr-2 h-4 w-4" />
                Utforska
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/favorites" className="cursor-pointer">
                <Heart className="mr-2 h-4 w-4" />
                Favoriter
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/orders" className="cursor-pointer">
                <ShoppingBag className="mr-2 h-4 w-4" />
                Beställningar
              </Link>
            </DropdownMenuItem>
          </>
        )}
        {isAdmin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/admin" className="cursor-pointer">
                <Shield className="mr-2 h-4 w-4" />
                Admin Panel
              </Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut} className="cursor-pointer">
          <LogOut className="mr-2 h-4 w-4" />
          Logga ut
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
